import moment from "moment";
import React from "react";
import submit from "submit-form";
import {
  invertColor,
  setIntervalX,
} from "../../../../../utils/annual-planner-helpers";

export const EventCard = ({
  event,
  type = "next",
  setDateFromState,
  setDateToState,
  horizontalScrollRef,
  annualPlannerMainRef,
}) => {
  const daysCounterColor = invertColor(event.eventColor);

  // Get the time remaining in days
  let timeLeft = moment(event.fromDate, "YYYYMMDD").diff(
    moment(moment().format("YYYYMMDD"), "YYYYMMDD"),
    "days"
  );

  // Get the phrase of the time remainig for the event
  timeLeft =
    timeLeft > 6
      ? Math.trunc(timeLeft / 7) > 1
        ? `${Math.trunc(timeLeft / 7)} Weeks Left`
        : `${Math.trunc(timeLeft / 7)} Week Left`
      : timeLeft > 1
      ? `${timeLeft} Days Left`
      : timeLeft < 1
      ? "Today"
      : `${timeLeft} Day Left`;

  const openIndividualEventModal = (
    { _id, name, description, fromDate, toDate, eventColor },
    mode
  ) => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "individual-event",
        eventName: name,
        eventDescription: description,
        eventFromDate: fromDate,
        eventToDate: toDate || "",
        eventColor,
        eventId: _id,
        mode,
      },
    });
  };

  const highlightCalendarEventHandler = async (event) => {
    const eventName = event.name.replace(/\s/g, "-").toLowerCase();

    // All the event cells that we want to blink
    const eventBoxes = document.getElementsByClassName(
      `calendar-custom-modifier ${eventName}`
    );

    const colorsBackup = Array.from(eventBoxes).map((element) => ({
      backgroundColor: element.style.backgroundColor,
      color: element.style.color,
    }));

    // Scroll to the top to see the calendar, and scroll the calendar to the beggining
    annualPlannerMainRef.current.scrollTo({ top: 0, behavior: "smooth" });
    horizontalScrollRef.current.scrollTo({
      left: 0,
      behavior: "smooth",
    });

    // Setting the new date range in which the calendar moves to bring into view the event
    setDateFromState(moment(event.fromDate, "YYYYMMDD").subtract(1, "months"));
    setDateToState(moment(event.fromDate, "YYYYMMDD").add(11, "months"));

    // Call a custom set interval that will execute only 4 times, to blink twice the event
    // The timeout is to give the scroll the time to get up to the top before blinking the event
    setTimeout(
      () =>
        setIntervalX(
          highlightEvent,
          300,
          4,
          event.eventColor,
          eventBoxes,
          colorsBackup
        ),
      700
    );
  };

  const highlightEvent = (
    [eventColor, eventBoxes, colorsBackup],
    iteration
  ) => {
    Array.from(eventBoxes).forEach((element, index) => {
      const elementCurrentBg = colorsBackup[index].backgroundColor;
      const elementCurrentColor = colorsBackup[index].color;
      const highlightColor = invertColor(eventColor);
      const oppositeHighlightColor = invertColor(
        highlightColor === "var(--white-87)" ? "#ffffff" : "#000000"
      );
      // Make it blink
      if (iteration === 1 || iteration === 3) {
        element.style.backgroundColor = highlightColor;
        element.style.color = oppositeHighlightColor;
      }
      // Restore to the original color
      if (iteration === 2 || iteration === 4) {
        element.style.backgroundColor = elementCurrentBg;
        element.style.color = elementCurrentColor;
      }
    });
  };

  if (type === "next")
    return (
      <div
        role="footer-card"
        className="events next"
        style={{ borderColor: event.eventColor }}
      >
        <div role="card-header">
          <span className="header-date">
            {event.toDate
              ? `${moment(event.fromDate, "YYYYMMDD").format(
                  "MMM D, YYYY"
                )} - ${moment(event.toDate, "YYYYMMDD").format("MMM D, YYYY")}`
              : moment(event.fromDate, "YYYYMMDD").format("MMM D, YYYY")}
          </span>
          <div className="header-actions">
            <div
              className="event-icon-button"
              onClick={() => highlightCalendarEventHandler(event)}
            >
              <img src="/img/new-icons/calendar-ico.svg" />
            </div>
            <div
              className="event-icon-button edit"
              onClick={() => openIndividualEventModal(event, "edit")}
            >
              <img src="/img/new-icons/edit-pencil.svg" />
            </div>
            <div
              className="event-icon-button"
              onClick={() => openIndividualEventModal(event, "remove")}
            >
              <img src="/img/new-icons/red-trash.svg" />
            </div>
            <div
              className="days-counter"
              style={{
                backgroundColor: event.eventColor,
                color: daysCounterColor,
              }}
            >
              {timeLeft}
            </div>
          </div>
        </div>
        <div className="event-title">{event.name}</div>
        <div className="event-description">{event.description}</div>
      </div>
    );

  if (type === "upcoming")
    return (
      <div
        role="footer-card"
        className="events upcoming"
        style={{ borderColor: event.eventColor }}
      >
        <div role="card-header">
          <span className="header-date">
            {event.toDate
              ? `${moment(event.fromDate, "YYYYMMDD").format(
                  "MMM D, YYYY"
                )} - ${moment(event.toDate, "YYYYMMDD").format("MMM D, YYYY")}`
              : moment(event.fromDate, "YYYYMMDD").format("MMM D, YYYY")}
          </span>
        </div>
        <div className="event-title">{event.name}</div>
        <div className="event-description">{event.description}</div>
        <div className="line-divider" />
        <div role="card-footer" className="events">
          <div
            className="days-counter upcoming"
            style={{
              backgroundColor: event.eventColor,
              color: daysCounterColor,
            }}
          >
            {timeLeft}
          </div>
          <div className="header-actions">
            <div
              className="event-icon-button"
              onClick={() => highlightCalendarEventHandler(event)}
            >
              <img src="/img/new-icons/calendar-ico.svg" />
            </div>
            <div
              className="event-icon-button edit"
              onClick={() => openIndividualEventModal(event, "edit")}
            >
              <img src="/img/new-icons/edit-pencil.svg" />
            </div>
            <div
              className="event-icon-button"
              onClick={() => openIndividualEventModal(event, "remove")}
            >
              <img src="/img/new-icons/red-trash.svg" />
            </div>
          </div>
        </div>
      </div>
    );
};
